module.exports = __webpack_public_path__ + "assets/icon-stars-outline-component.34b1ead4.svg";